import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';          // import signalR
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignlrService {

   private  connection: any = new signalR.HubConnectionBuilder().withUrl(`${environment.api.hubUrl}`, {
     skipNegotiation: true,
     transport: signalR.HttpTransportType.WebSockets
    })
   .build();
   
  private receivedMessageObject: MessageDto = new MessageDto();
  private sharedObj = new Subject<MessageDto>();

  constructor() { 
    this.connection.onclose(async () => {
      await this.start();
    });
   this.connection.on("ReceiveOne", (user: any) => { this.mapReceivedMessage(user); });
   this.start();                 
  }


  // Strart the connection
  public async start() {
    try {
      await this.connection.start();
      console.log("connected");
    } catch (err) {
      console.log(err);
      setTimeout(() => this.start(), 5000);
    } 
  }

  private mapReceivedMessage(user: string): void {
    this.receivedMessageObject.user = user;
    this.sharedObj.next(this.receivedMessageObject);
 }

  public retrieveMappedObject(): Observable<MessageDto> {
    return this.sharedObj.asObservable();
  }


}
export class MessageDto {
  public user: string = '';
}